import React from "react"
import Typography from "../reusable/Typography/Typography"
import {WithBrand, WithoutBrand} from "../../utility/Types"

type Props = {
	facts: WithBrand[] | WithoutBrand[]
}
function BrandFacts({facts}:Props) {
	if (facts?.length) {
		return (
			<div style={{gap: "40px", maxWidth: "540px"}}
				className="d-flex align-items-center justify-content-start flex-column">
				{facts?.map((fact, index) => <div
					key={index}
					className="d-flex align-items-center text-center justify-content-center flex-column">
					<Typography variant="bodySmBold"
						style={{fontSize: "20px", color: "#fff", lineHeight: "32px"}}>{fact.title}</Typography>
					<Typography variant="bodySm"
						style={{fontSize: "16px", color: "#fff", lineHeight: "24px", opacity: "0.6", textAlign: "center"}}>{fact.description}</Typography>
				</div>)}
			</div>
		)
	}

	return <></>
}

export default BrandFacts
